"use strict";

(function () {
  var baseURL = "https://cdn.shopify.com/shopifycloud/checkout-web/assets/";
  var scripts = ["https://cdn.shopify.com/shopifycloud/checkout-web/assets/runtime.latest.en.12f1297c1bc60b67102b.js", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/472.latest.en.d0f7ab639a07ec458210.js", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/748.latest.en.ee3af826f9b349c71c90.js", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/40.latest.en.43731eb585ef4ff8d8b1.js", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/app.latest.en.efe05aa7882c0cd17155.js", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/240.latest.en.d48b54ea867b809eedba.js", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/904.latest.en.01a28a5ca38afc4a9fa1.js", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/44.latest.en.ed5da7e5a1dddfca0e79.js", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/OnePage.latest.en.52201164e80d74dec26a.js"];
  var styles = ["https://cdn.shopify.com/shopifycloud/checkout-web/assets/472.latest.en.ce3c6a8cbd6993df914d.css", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/app.latest.en.e5a7f63ca146c0549466.css", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/904.latest.en.4d273af8acf76b1eb555.css", "https://cdn.shopify.com/shopifycloud/checkout-web/assets/457.latest.en.0c56a163bd2cc1f47527.css"];
  var fontPreconnectUrls = [];
  var fontPrefetchUrls = [];
  var imgPrefetchUrls = [];
  function preconnect(url, callback) {
    var link = document.createElement('link');
    link.rel = 'dns-prefetch preconnect';
    link.href = url;
    link.crossOrigin = '';
    link.onload = link.onerror = callback;
    document.head.appendChild(link);
  }
  function preconnectAssets() {
    var resources = [baseURL].concat(fontPreconnectUrls);
    var index = 0;
    (function next() {
      var res = resources[index++];
      if (res) preconnect(res[0], next);
    })();
  }
  function prefetch(url, as, callback) {
    var link = document.createElement('link');
    if (link.relList.supports('prefetch')) {
      link.rel = 'prefetch';
      link.fetchPriority = 'low';
      link.as = as;
      if (as === 'font') link.type = 'font/woff2';
      link.href = url;
      link.crossOrigin = '';
      link.onload = link.onerror = callback;
      document.head.appendChild(link);
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.onloadend = callback;
      xhr.send();
    }
  }
  function prefetchAssets() {
    var resources = [].concat(scripts.map(function (url) {
      return [url, 'script'];
    }), styles.map(function (url) {
      return [url, 'style'];
    }), fontPrefetchUrls.map(function (url) {
      return [url, 'font'];
    }), imgPrefetchUrls.map(function (url) {
      return [url, 'image'];
    }));
    var index = 0;
    (function next() {
      var res = resources[index++];
      if (res) prefetch(res[0], res[1], next);
    })();
  }
  function onLoaded() {
    preconnectAssets();
    prefetchAssets();
  }
  if (document.readyState === 'complete') {
    onLoaded();
  } else {
    addEventListener('load', onLoaded);
  }
})();